type PageTitleProps = {
    className?: string;
    children: React.ReactNode,
}

export const PageTitle = ({ children, className }: PageTitleProps) => (
    <h2 className={`m-0 mb-2 ${className}`}>{children}</h2>
);
